import React from 'react';
import 'semantic-ui-css/semantic.min.css';
import ReportModelBase from '../ReportModelBase';
import { Table } from 'semantic-ui-react';

class RehiredEmployeeReportModel extends ReportModelBase {

    constructor(props){
        super(props);
        this.searchUrl = "api/Reports/RehiredEmployeeReport";
        this.title = "Employee Report Group by Position";
        this.exportToExcelUrl = "api/Reports/ExportRehiredEmployeeReportToExcel";
        this.exportToPdfUrl = "api/Reports/ExportRehiredEmployeeReportToPDF";
    }

    toTableRow = (rowData) => {
        return (
            <Table.Row>
                <Table.Cell>{rowData["Employee No"]}</Table.Cell>
                <Table.Cell>{rowData["Employee"]}</Table.Cell>
            </Table.Row>
        );
    }

    createColumnHeaders = () => {
        return (
            <Table.Row>
                <Table.HeaderCell>Employee No</Table.HeaderCell>
                <Table.HeaderCell>Employee</Table.HeaderCell>
            </Table.Row>
        );
    }

}
export default RehiredEmployeeReportModel;